import { o as p } from "../../unsafe-svg-By8nNw37.js";
import "../../sp-button-DfcLwvTE.js";
import "../../sp-switch-BJhZAN4S.js";
import v from "../../events/ActivationEvent.js";
import { LinkableCard as m } from "../../lib/LinkableCard.js";
import { c as f } from "../../creative-cloud-icon-CELqJJSR.js";
import { s as h } from "../../shared-CxhTCuEO.js";
import { i as u, x as a, s as y } from "../../lit-element-6iugfgmM.js";
import { Localize as b } from "../../lib/I18N.js";
import { Analytics as g } from "../../lib/Analytics.js";
import { n as c } from "../../property-BWlAHqg_.js";
import { e as x } from "../../custom-element-wk-AooBb.js";
const k = u`:host{background:var(--spectrum-global-color-gray-75);border:1px solid var(--spectrum-global-color-gray-300);box-shadow:none}:host(:hover),:host(:focus){border-color:var( --spectrum-card-border-color-key-focus, var(--spectrum-alias-border-color-focus));box-shadow:0 0 0 2px var( --spectrum-card-border-color-key-focus, var(--spectrum-alias-border-color-focus))}.anchor{bottom:0;left:0;right:0;position:absolute;top:0;visibility:visible;z-index:1}.actions{z-index:2}.card-footer{align-items:center;background-color:#fafafa;border-top:1px solid var(--spectrum-global-color-gray-300);display:flex;height:60px;justify-content:center;padding:0 15px}.description{flex:1;list-style:none;margin:0;padding:0}.overlay-title,.title{font-weight:600;margin-block-end:0px;margin-block-start:0px}.subtitle,.title{color:var(--spectrum-global-color-gray-600)}.activation-button{margin-right:5px}.overlay-subtitle,.overlay-title{color:var(--spectrum-global-color-gray-50)}`, $ = { "specimen-card.action.add-fonts": "Add fonts", "specimen-card.action.remove-fonts": "Remove fonts", "specimen-card.view-family": "View family" };
var w = Object.defineProperty, A = Object.getOwnPropertyDescriptor, r = (t, i, n, s) => {
  for (var l, o = s > 1 ? void 0 : s ? A(i, n) : i, d = t.length - 1; d >= 0; d--) (l = t[d]) && (o = (s ? l(i, n, o) : l(o)) || o);
  return s && o && w(i, n, o), o;
};
let e = class extends g(b(m(y), $)) {
  constructor() {
    super(...arguments), this.activated = !1, this.footer = !1, this._openFDPAnalytics = (t) => {
      this.sendAnalyticsEvent("specimen-fdp-open", { title: t });
    };
  }
  static get styles() {
    return [h, k];
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => this._openFDPAnalytics(this.title));
  }
  render() {
    return this.renderLinkable(a`<div class="specimen" @click="${this._openFDPAnalytics}"><slot></slot>${this._footer()}</div>${this.renderOverlay()}`);
  }
  handleActivationSwitchChange(t) {
    t.stopPropagation(), this.dispatchEvent(new v({ isActivated: !this.activated }));
  }
  stopKeypressPropagation(t) {
    t.stopPropagation();
  }
  handleEnterKeydown(t) {
    if (!t.target) return;
    t.stopPropagation();
    const { code: i } = t;
    i === "Enter" && t.target.click();
  }
  renderActions() {
    return a`<div class="actions"><sp-button class="activation-button" treatment="fill" variant="secondary" @click="${this.handleActivationSwitchChange}"><sp-icon size="s" slot="icon">${p(f)}</sp-icon>${this.activated ? this.t("specimen-card.action.remove-fonts") : this.t("specimen-card.action.add-fonts")}</sp-button></div>`;
  }
  renderOverlay() {
    if (!this.footer) return a`<div class="overlay">${this.renderActions()}<div class="overlay-title">${this.title}</div><div class="overlay-subtitle">${this.subtitle}</div></div>`;
  }
  _footer() {
    if (this.footer) return a`<div class="card-footer"><div class="description"><div class="title">${this.title}</div><div class="subtitle">${this.subtitle}</div></div><div class="actions"><div class="subtitle">${this.t("specimen-card.view-family")}</div></div></div>`;
  }
};
r([c({ type: Boolean })], e.prototype, "activated", 2), r([c({ type: String })], e.prototype, "title", 2), r([c({ type: String })], e.prototype, "subtitle", 2), r([c({ type: Boolean })], e.prototype, "footer", 2), e = r([x("af-specimen-card")], e);
const K = e;
export {
  K as default
};
//# sourceMappingURL=SpecimenCard.js.map
